import { ReduceStore } from "flux/utils";
import { Map } from "immutable";
import AppDispatcher from "../AppDispatcher";
import CurrentOrganizationStore from "./CurrentOrganizationStore";
import CurrentOrganizationIdStore from "./CurrentOrganizationIdStore";
import CurrentUserIdStore from "./CurrentUserIdStore";
import MembershipStore from "./MembershipStore";
import Constants from "../Constants";

class EulaStore extends ReduceStore {
  getInitialState() {
    return Map();
  }

  reduce(state, action) {
    this.getDispatcher().waitFor([
      CurrentUserIdStore.getDispatchToken(),
      CurrentOrganizationIdStore.getDispatchToken(),
      CurrentOrganizationStore.getDispatchToken(),
      MembershipStore.getDispatchToken(),
    ]);

    // If the user's signature was acknowledged, set the signature status for this org to true.
    if (action.actionType == Constants.EULA_SIGNATURE_ACKNOWLEDGED) {
      return state.update(action.organizationId, Map(), (orgSettings) =>
        orgSettings.set("userSignedEula", true)
      );
    }

    // Otherwise, it's an update triggered somewhere else, so let's make sure we have up-to-date
    // eula info.
    if (
      CurrentUserIdStore.hasChanged() ||
      CurrentOrganizationIdStore.hasChanged() ||
      CurrentOrganizationStore.hasChanged() ||
      MembershipStore.hasChanged()
    ) {
      const org = CurrentOrganizationStore.getState();
      const currentMembership = MembershipStore.getMembership(
        CurrentUserIdStore.getState(),
        CurrentOrganizationIdStore.getState()
      );
      return state.update(
        CurrentOrganizationIdStore.getState(),
        Map(),
        (orgSettings) =>
          orgSettings
            .set("requiredEulaContentId", org && org.requiredEulaContentId)
            .update(
              "userSignedEula",
              false,
              (oldValue) =>
                oldValue ||
                (!!currentMembership && !!currentMembership.eulaAcceptance)
            )
      );
    }

    return state;
  }

  getOrgState(organizationId) {
    return this.getState().get(organizationId, Map());
  }

  /**
   * Indicates whether the user needs to sign the EULA in this organization
   */
  eulaRequired() {
    const state = this.getOrgState(CurrentOrganizationIdStore.getState());
    return (
      state.get("requiredEulaContentId", null) &&
      !state.get("userSignedEula", false)
    );
  }

  eulaContentId() {
    const state = this.getOrgState(CurrentOrganizationIdStore.getState());
    return state.get("requiredEulaContentId");
  }
}

const instance = new EulaStore(AppDispatcher);
export default instance;
